import { useEffect, useRef } from "react";
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import AutocompleteControlled from "components/Controllers/Autocomplete";
import InputControlled from "components/Controllers/Input";
import CreditCardInput from "react-credit-card-input";
import { Controller } from "react-hook-form";
import { customTextLabel } from "../helpers/customTextLabels";

export default function CARDForm({
  control,
  setValue,
  documents,
  samePersonPay,
}) {
  return (
    <Box>
      <Grid container spacing={2} id="container" alignItems="center">
        <Grid item xs={12} md={6}>
          <CreditCardInput
            customTextLabels={customTextLabel}
            cardCVCInputProps={{
              onChange: (e) =>
                setValue("card_cvv", e.target.value, { shouldValidate: true }),
            }}
            cardExpiryInputProps={{
              onChange: (e) => {
                setValue(
                  "card_expiration_date",
                  e.target.value?.replace(/\s/g, "", { shouldValidate: true })
                );
              },
            }}
            cardNumberInputProps={{
              onChange: (e) =>
                setValue("card_number", e.target.value, {
                  shouldValidate: true,
                }),
            }}
            fieldClassName="input"
          />
        </Grid>
        {!samePersonPay && (
          <>
            <Grid item xs={12} md={6}>
              <AutocompleteControlled
                label="Tipo de Documento"
                name="possible_customer_document_type"
                control={control}
                rules={{ required: !samePersonPay }}
                options={documents}
                disabled={samePersonPay}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InputControlled
                label="N° Documento"
                name="possible_customer_document_number"
                control={control}
                rules={{ required: true }}
                inputProps={{ maxLength: 15 }}
                disabled={samePersonPay}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InputControlled
                label="Nombres"
                name="possible_customer_firstname"
                control={control}
                rules={{ required: !samePersonPay }}
                inputProps={{ maxLength: 30 }}
                disabled={samePersonPay}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InputControlled
                label="Apellidos"
                name="possible_customer_lastname"
                control={control}
                rules={{ required: !samePersonPay }}
                inputProps={{ maxLength: 30 }}
                disabled={samePersonPay}
              />
            </Grid>
          </>
        )}
        <Grid item xs={12} md={6}>
          <Controller
            rules={{ required: true }}
            control={control}
            name={"installments"}
            defaultValue={"1"}
            render={({ field }) => (
              <FormControl fullWidth>
                <InputLabel>{"Número de cuotas"}</InputLabel>
                <Select
                  MenuProps={{ style: { height: 250 } }}
                  {...field}
                  fullWidth
                  defaultValue={"1"}
                  variant="standard"
                  placeholder="Número de cuotas"
                  onChange={(e) => field.onChange(e.target.value)}
                >
                  {[...Array.from({ length: 36 }, (_, i) => i + 1)].map(
                    (item) => (
                      <MenuItem key={item} value={item.toString()}>
                        {item.toString()}
                      </MenuItem>
                    )
                  )}
                </Select>
              </FormControl>
            )}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
